<template>
    <v-container fluid>
        <v-row>
            <v-col cols="6" sm="6" class="text-left" style="margin: 0 auto;">
                <SelectSeries ref="selectSeries" @presetSelectSerie="presetSelectSerie" @refreshRaces="(bandRaceList) => $emit('refreshRaces',bandRaceList)"/>
            </v-col>
        </v-row>
        <SeriesDetails />
    </v-container>
</template>

<script>
import SelectSeries from "@/components/series/SelectSeries.vue";
import SeriesDetails from "@/components/series/SeriesDetails.vue";

export default {
  components: {
      SeriesDetails,
      SelectSeries
  },
  methods: {
    presetSelectSerie() {
    }
  }
}
</script>

<style>
@media screen and (max-width: 499px) {
    .v-breadcrumbs a {
        font-size: 12px !important;
    }
}
</style>